// extracted by mini-css-extract-plugin
module.exports = {"slideShowIconContainer":"_3860C","slideShowIconBackground":"_1idEG"};